import React, { FC, useCallback, useMemo, useState } from 'react';
import { Modal } from '@src/core/Modal';
import { classnames } from '@src/utils/classnames';
import { ISwiper, Swiper } from '@src/atoms/Swiper/Swiper';
import { Box } from '@src/atoms/Box';
import { Text } from '@src/atoms/Text';
import { Divider } from '@src/atoms/Divider';
import { Button } from '@src/atoms/Button';
import { ISelectMenuPortal } from '../../models';

import styled from './MenuPortalShortView.scss';

interface IProps extends ISelectMenuPortal {}

export const MenuPortalShortView: FC<IProps> = (props) => {
  const { children, selectProps, isMulti } = props;
  const { menuTitle, setMenuIsOpen, classNamePrefix } = selectProps;
  const classes = classnames(styled.root, classNamePrefix);
  const selectId = selectProps['data-id'];

  const [swiperController, setSwiperController] = useState<ISwiper | null>(null);

  const onBackdropClick = useCallback(() => {
    setMenuIsOpen?.(false);
  }, [setMenuIsOpen]);

  const handleSlideChangeTransitionEnd = () => {
    if (swiperController?.activeIndex === 0) {
      swiperController.once('destroy', () => setTimeout(onBackdropClick, 100));
      swiperController.destroy();
    }
  };

  const slides = useMemo(
    () => [
      {
        id: 'transparent',
        content: <Box bgColor={'basicTransparent'} style={{ height: '100vh', width: '100vw' }} />,
      },
      {
        id: 'select',
        /**  TODO: теперь есть отдельный компонент SwipeDialog, переверстать */
        content: (
          <Box className={classes} column bgColor="basicWhite" data-id={`${selectId}_menuWrapperMobile`}>
            <Box className={styled.rootMarkContainer} justifyContent="center" alignItems="center">
              <Box bgColor="basicGrey" className={styled.rootMark} />
            </Box>
            <Box justifyContent="center" alignItems="center" className={styled.rootTitle} column>
              <Text id={'menuTitle'} weight="bold" className={styled.rootTitleText}>
                {menuTitle}
              </Text>
              <Divider />
            </Box>
            {children}

            {isMulti && (
              <Box paddingTop={20} paddingBottom={24} paddingLeft={16} paddingRight={16}>
                <Button fullWidth size="lg" id="submitBtn" onClick={onBackdropClick}>
                  Готово
                </Button>
              </Box>
            )}
          </Box>
        ),
      },
    ],
    [classes, menuTitle, children, isMulti, onBackdropClick],
  );

  return (
    <Modal open onBackdropClick={onBackdropClick}>
      <Swiper
        slides={slides}
        direction={'vertical'}
        slidesPerView={1}
        initialSlide={1}
        onSwiper={setSwiperController}
        onSlideChangeTransitionEnd={handleSlideChangeTransitionEnd}
      />
    </Modal>
  );
};
